import React from 'react';
import {Button } from 'reactstrap';
import PopupWindow from 'components/ModalPopup';
import { connect } from 'react-redux';
import { UserAction } from 'redux/actions';
import { checkPermissions } from 'hooks';

const SuspendAccountButton = (props) => {
    
    const [open, setOpen] = React.useState(false);
    return (
      <>
        {checkPermissions(props.loginData, 'suspend_account') ? (
          <PopupWindow
            buttonStyle={{ marginTop: 10, width: '100%' }}
            handlePopup={popup => {
              setOpen(popup);
            }}
            openWindow={open}
            title={(props.user && !props.user.is_suspended)?'Suspend Account':'UnSuspend Account'}
            launchButtonText={(props.user && !props.user.is_suspended)?'Suspend Account':'UnSuspend Account'}
          >
            <div>
              <div>{(props.user && !props.user.is_suspended)?'Are you sure? Do you want to suspend this account?':'Are you sure? Do you want to UnSuspend this account?'}</div>
              <div style={{ display: 'flex' }}>
                <Button
                  style={{
                    padding: 'auto',
                    width: 100,
                    marginTop: 20,
                    marginRight: 10,
                  }}
                  size="sm"
                  onClick={() => {
                    setOpen(false)
                    if(!props.user.is_suspended)
                        props.suspendAccount({ user_id: props.user_id });
                    else
                        props.suspendAccount({ revoke: 1, user_id: props.user_id })
                  }}
                  block
                >
                  Yes
                </Button>
                <Button
                  color="primary"
                  style={{ padding: 'auto', width: 100, marginTop: 20 }}
                  size="sm"
                  onClick={() => setOpen(false)}
                  block
                >
                  No
                </Button>
              </div>
            </div>
          </PopupWindow>
        ) : (
          <Button
            style={{ marginTop: 10, width: '100%' }}
            disabled={true}
            className={'border-0 btn-disabled'}
            color="primary"
            size="sm"
          >
            Suspend Account
          </Button>
        )}
      </>
    );
};

const mapStateToProps = (state) => ({
    user: (state.user && state.user.userProfile && state.user.userProfile.userdetails) ? state.user.userProfile.userdetails : null,
    loginData: (state.loginReducer && state.loginReducer.loginData && state.loginReducer.loginData.user) ? state.loginReducer.loginData.user : null,
});
const mapDispatchToProps = (dispatch) => ({
    suspendAccount: (payload) => dispatch(UserAction.suspendAccount(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(SuspendAccountButton);
